<div class="afftrans-wrapper">
  <div class="hero card-glass mb-3">
    <div class="crumb">
      <a [routerLink]="['/utilisateur/espace/busnes/activite', safeName, accountNumber]" class="crumb-link">
        <i class="bi bi-arrow-left"></i> Retour activite business
      </a>
      <span class="crumb-current">Transferts professionnels</span>
    </div>
    <div class="hero-flex">
      <div>
        <p class="eyebrow">Spay · Compte pro</p>
        <h1>{{bDescription}}</h1>
        <p class="lead">Historique des transferts effectués pour {{accountNumber}}.</p>
      </div>
      <div class="pill-row d-none d-sm-flex">
        <span class="pill pill-strong">Transferts</span>
        <span class="pill">Entrants / Sortants</span>
      </div>
    </div>
  </div>

  <div class="card-glass p-3 mb-3">
    <div class="d-flex flex-column flex-sm-row justify-content-between align-items-start align-items-sm-center gap-2">
      <h4 class="mb-0">Historique</h4>
      <div class="d-flex align-items-center gap-2 w-100 w-sm-auto">
        <label class="text-muted mb-0" for="monthSelectTransferts">Mois</label>
        <select id="monthSelectTransferts"
          class="form-select form-select-sm bg-dark text-light border-secondary w-100 w-sm-auto"
          [(ngModel)]="selectedMonth" (change)="applyMonthFilter(selectedMonth)">
          <option *ngFor="let m of monthOptions" [value]="m.value">{{ m.label | titlecase }}</option>
        </select>
      </div>
    </div>
    <!--<p class="text-muted small mb-0">Par défaut, seules les opérations du mois en cours s’affichent. Sélectionnez un mois passé pour consulter les transferts déjà chargés.</p>-->
  </div>

  <div class="row g-3">
    <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12" *ngFor="let t of transferlist">
      <div class="card card-glass h-100">
        <div class="card-header generalbgColorV2 text-white text-center font-weight-bolder">
          {{t.date | date:"dd/MM/yyyy H:mm:ss"}}
        </div>
        <div class="card-body">
          <div *ngIf="t.type==1; else inbound">
            <div class="metric-row"><span>Destinataire</span><strong>{{t.destinataire}}</strong></div>
            <div class="metric-row"><span>Montant</span><strong>{{t.amount | currency: t.sigleMonnaie}}</strong></div>
            <div class="metric-row"><span>Motif</span><strong>{{t.motif}}</strong></div>
            <div class="metric-row"><span>Type</span><strong class="text-danger"><i
                  class="bi bi-arrow-up"></i></strong></div>
          </div>
          <ng-template #inbound>
            <div class="metric-row"><span>Émetteur</span><strong>{{t.emeteur}}</strong></div>
            <div class="metric-row"><span>Montant</span><strong>{{t.amount | currency:t.sigleMonnaie}}</strong></div>
            <div class="metric-row"><span>Motif</span><strong>{{t.motif}}</strong></div>
            <div class="metric-row"><span>Type</span><strong class="text-success"><i
                  class="bi bi-arrow-down"></i></strong></div>
          </ng-template>
        </div>
        <div class="card-footer bg-transparent border-0 text-end">
          <button type="button" class="btn btn-outline-danger btn-sm" disabled><i
              class="bi bi-trash mr-2"></i></button>
        </div>
      </div>
    </div>
    <div class="col-12" *ngIf="!transferlist || transferlist.length === 0">
      <div class="card card-glass p-3 text-center text-muted">
        Aucun transfert enregistré.
      </div>
    </div>
  </div>
</div>
